import { render } from "./userDataStatistics.vue?vue&type=template&id=d862ccfa&scoped=true"
import script from "./userDataStatistics.vue?vue&type=script&lang=js"
export * from "./userDataStatistics.vue?vue&type=script&lang=js"

import "./userDataStatistics.vue?vue&type=style&index=0&id=d862ccfa&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d862ccfa"]])

export default __exports__